<template>
  <el-dialog width="520px" title="添加产品"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productAddVisible">
    <div class="details">

      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="right"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-form-item prop="product_id" label="产品名">
          <el-select v-model="currencyForm.product_id" @change="handleChangeProduct">
            <el-option :value="item.id" :label="item.product_name" v-for="item in productList"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="modules" label="可选模块">
          <ul class="modules_ul" v-if=" currencyForm.modules_info &&  currencyForm.modules_info.length>0">
            <li v-for="item in currencyForm.modules_info" v-if="item.value_code">
              <span  v-text="item.module_name"></span>: <span v-text="item.module_value"></span>
<!--              <template v-if="item.module_values && item.module_values.length>0">-->
<!--                <span v-if="item.module_code == '13'" >-->
<!--                </span>-->
<!--                <span v-else v-text="item.module_values.find(find => find.id == item.module_value_id).module_value"></span>-->
<!--              </template>-->
<!--              -->
            </li>
          </ul>
            <el-button type="text" @click="handleClickModules">选择</el-button>
        </el-form-item>

        <el-form-item prop="num" label="数量">
            <el-input-number :controls="false"  v-model="currencyForm.num" :min="0" :step="0" placeholder="请输入正整数"></el-input-number>
        </el-form-item>

        <el-form-item prop="order_num" label="订单号">
          <el-input   v-model="currencyForm.order_num"  placeholder="请输入订单号"></el-input>
        </el-form-item>

        <el-form-item prop="date" label="有效期至">

          <el-date-picker
            v-model="currencyForm.date"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="admin_note" label="备注">
          <el-input  type="textarea" v-model="currencyForm.admin_note"  placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>

    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认添加</el-button>
    </div>
    <modulesChange :modulesVisible.sync="modulesVisible" v-if="modulesVisible" :modulesInfo="currencyForm.modules_info" @success="modulesSuccess"/>

  </el-dialog>
</template>
<script>

import {adminAddProduct,adminProductList } from '@/api/api'
import {mapState} from "vuex";
import modulesChange from "./modules_change";
import {convertToCurrentTimezone,convertToUTC} from '@/utils'
export default {
  name: 'product_add',
  components: {
    modulesChange
  },
  props: {
    productAddVisible: {
      type: Boolean,
      default: false,
    },
    uid: {
      type: Number,
      default: '',
    },
    companyId: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        uid:'',
        company_id: 0,
        product_id:'',
        product_code:'',
        modules: [],
        modules_info: [],
        num:undefined,
        order_num: "",
        date:[],
        start_date: "",
        end_date: "",
        admin_note: ""
      },
      currencyFormRules:{
        product_id:[{ required: true, message: '请选择产品', trigger: 'change'}],
        modules:[{ required: true, message: '请选择可选模块', trigger: 'change'}],
        num:[{ required: true, message: '请输入数量', trigger: 'blur'}],
        order_num:[{ required: true, message: '请输入订单编号', trigger: 'blur'}],
        date:[{ required: true, message: '请选中有效期至', trigger: 'change'}],
      },
      productList:[],
      modulesVisible:false
    }
  },

  created() {
    this.getAdminProductList()
    if(this.uid){
      this.currencyForm.uid = this.uid
    }
    if(this.companyId){
      this.currencyForm.company_id = this.companyId
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 获取产品列表
    getAdminProductList(){
      adminProductList().then(res => {
        if (res.code === 200) {
          this.productList = res.data
        }else{

        }
      }).catch((e) => {

      })
    },
    // 选择产品
    handleChangeProduct(val){
        let data = this.productList.find(find => find.id == val)
        this.currencyForm.product_code = data.product_code
      // 1. 分离出非目标元素
      const others = data.modules.filter(item => item.module_code !== '13');
      // 2. 提取所有目标元素
      const targets = data.modules.filter(item => item.module_code === '13');
      // 3. 合并数组（非目标在前，目标在后）
      const sortedData = [...others, ...targets];
      this.currencyForm.modules_info = sortedData
    },
    // 选择模块
    handleClickModules(){
      if(!this.currencyForm.product_id){
        this.$message.error('请先选择产品')
        return false
      }
      this.modulesVisible = true
    },
    // 选择后的回调
    modulesSuccess(data){
      if(data){
        this.currencyForm.modules_info = JSON.parse(JSON.stringify(data))
          this.currencyForm.modules = this.currencyForm.modules_info.map((item)=>{
            return {
              module_id:item.id,
              module_code:item.module_code,
              module_value_id:item.module_value_id,
              module_value:item.module_value,
              value_code:item.value_code,
            }
          })
          this.$refs.currencyForm.clearValidate('modules')

        }
    },


    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postDataInfo = {
            uid:this.currencyForm.uid,
            company_id:this.currencyForm.company_id,
            product_id:this.currencyForm.product_id,
            product_code:this.currencyForm.product_code,
            module_require:this.currencyForm.modules,
            num:this.currencyForm.num,
            order_num:this.currencyForm.order_num,
            start_date:convertToUTC(this.currencyForm.date[0],'datetime'),
            end_date:convertToUTC(this.currencyForm.date[1],'datetime'),
            admin_note:this.currencyForm.admin_note,
          }

          this.BtnDisabled = true
          adminAddProduct(postDataInfo).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '新增成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.BtnDisabled = false
                  this.$emit('success')
                  this.$emit('update:productAddVisible', false)
                }
              })
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productAddVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
::v-deep .el-input-number{
  width: 100%;
  .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-date-editor{
  width: 100%;

}
.modules_ul{
  width: 100%;
  li{
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
